import { render, staticRenderFns } from "./detailListnew.vue?vue&type=template&id=4e7d5996&scoped=true"
import script from "./detailListnew.vue?vue&type=script&lang=js"
export * from "./detailListnew.vue?vue&type=script&lang=js"
import style0 from "./detailListnew.vue?vue&type=style&index=0&id=4e7d5996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7d5996",
  null
  
)

export default component.exports